// extracted by mini-css-extract-plugin
export default {"container":"EsteticPrice_container__yZhsz","title":"EsteticPrice_title__16Oea","text":"EsteticPrice_text__GSG9n","priceContent":"EsteticPrice_priceContent__eBnt+"};